import { Component, OnInit, ViewChild } from '@angular/core';
import { Modules, NewBusiness, PSIOperators } from 'src/app/_common/_enum/module.enum';
import { SubmissionsService } from 'src/app/submissions/_services/submissions.service';
import { Router } from '@angular/router';
import { RESULTS_NOT_FOUND, SUBMISSION_MSGS } from 'src/app/_common/product-config';
import { HeaderData } from 'src/app/_models/header-data';
import { StatusCode, DiceQuoteTypes } from 'src/app/_common/_enum/module.enum';
import { NewBusinessService } from '../_services/new-business.service';
import { CommonService } from 'src/app/_services/common.service';

@Component({
  selector: 'app-new-business',
  templateUrl: './new-business.component.html',
  styleUrls: ['./new-business.component.scss']
})
export class NewBusinessComponent implements OnInit {

  //Create HeaderData object to show the Data on Blue Header.
  private headerData:HeaderData;

  private runningServices = [];

  //private selectedBusiness: string = NewBusiness.SUBMISSIONS;

  private selectedNiche: any = "";
  private selectedProducerCode: any = "";
  private niches: any = [];
  private isSubmitted: boolean = false;
  private nicheLoading: boolean = false;
  private diceQuoteTypesEnum = DiceQuoteTypes;
  private isBusinessLookup: boolean = false;
  private newBusiness: any;
  
  resultsNotFound = RESULTS_NOT_FOUND;
  submissionsMsgs = SUBMISSION_MSGS;

  @ViewChild("chooseNicheAndProducerCodeModal", {static: false}) chooseNicheAndProducerCodeModal;
  constructor(private router: Router, private newBusinessService:NewBusinessService, private commonService:CommonService) { }

  ngOnInit() {
    /* Setting Headers Starts */
    this.headerData = new HeaderData();
    this.setHeaderData();
    /* Setting Headers Ended */

    let isSubmission = this.commonService.checkPermission(this.ModuleEnum.NBSubmission);

    if(isSubmission) {
      this.selectedBusiness = this.NewBusinessEnum.SUBMISSIONS;
    }else{
      this.selectedBusiness = this.NewBusinessEnum.DICE;
    }
    
    /* if(isSubmission && !this.selectedBusiness){
      this.selectedBusiness = NewBusiness.SUBMISSIONS;
    } */
    
    if(history && history.state && history.state.selectedBusiness){
      this.selectedBusiness = history.state.selectedBusiness;
    }

    if(this.newBusinessService.hasOpenModals()) {
      this.newBusinessService.closeModal();
    }
  }
  setHeaderData(){
    this.headerData.pageTitle = "New Business";
    this.headerData.breadcrumb = null;

    this.newBusinessService.header = this.headerData;
  }

  get selectedBusiness(){
    return this.newBusinessService.selectedBusiness;
  }
  set selectedBusiness(_selectedBusiness){
    this.newBusinessService.selectedBusiness = _selectedBusiness;
  }

  fetchNiches(){
    this.nicheLoading = true;
    this.selectedNiche = "";
    this.selectedProducerCode = "";
    
    let nichesSubscription = this.newBusinessService.fetchNiches().subscribe((_niches:any) => {
      this.nicheLoading = false;
      this.niches = _niches;
      
      /* console.log(this.niches); */
      
      if(this.niches == null){
        this.newBusinessService.openModal('error', '');
      }
      else{
        if(this.niches && (this.niches.length > 1 || (this.niches.length == 1 && this.niches[0].producers && this.niches[0].producers.length > 1))){
          if(this.niches.length == 1 ){
            this.selectedNiche = this.niches[0];
          }
          this.newBusinessService.openModal('none', this.chooseNicheAndProducerCodeModal, false, 'static');
        }
        else if(this.niches){
          this.isBusinessLookup = true;
          this.selectedNiche = this.niches[0];
          this.selectedProducerCode = this.selectedNiche.producers[0];
          if(!this.selectedNiche.isDice){
            this.router.navigate(["newbusiness/submissions/create"], {state: {selectedNiche: this.selectedNiche, selectedProducer: this.selectedProducerCode, isBusinessLookup: this.isBusinessLookup, isDice: this.selectedNiche.isDice}});
          }
          else{
            let _quoteDetails = {
              diceQuoteType: DiceQuoteTypes.New,
              applicationId: null,
              quoteId: null
            };
            this.router.navigate(["newbusiness/dice/create"], {state: {selectedNiche: this.selectedNiche, selectedProducer: this.selectedProducerCode, diceQuoteDetails: _quoteDetails, isBusinessLookup: this.isBusinessLookup, isDice: this.selectedNiche.isDice}});
          }
        }
      }
    },
    error=>{
      this.nicheLoading = false;
        this.newBusinessService.openModal('error', '');
    });

    this.runningServices.push(nichesSubscription);
  }

  get ModuleEnum(){
    return Modules;
  }

  get NewBusinessEnum(){
    return NewBusiness;
  }

  get PSIOperatorsEnum(){
    return PSIOperators;
  }

  changeNewBusinessList(_business){
    this.selectedBusiness = _business;
  }


  selectNiche(){
    this.selectedProducerCode = "";
    if(this.selectedNiche && this.selectedNiche.producers && this.selectedNiche.producers.length == 1){
      this.selectedProducerCode = this.selectedNiche.producers[0];
    }
  }

  onContinueNewBusiness(_modal){
    if(this.selectedNiche && this.selectedProducerCode){
      this.isBusinessLookup = true;
      _modal.close();      
      if(this.selectedNiche.isDice){
        let _quoteDetails = {
          diceQuoteType: DiceQuoteTypes.New,
          applicationId: null,
          quoteId: null
        };
        this.router.navigate(["newbusiness/dice/create"], {state: {selectedNiche: this.selectedNiche, selectedProducer: this.selectedProducerCode, diceQuoteDetails: _quoteDetails, isBusinessLookup: this.isBusinessLookup, isDice: this.selectedNiche.isDice}});
      }
      else{
        this.router.navigate(["newbusiness/submissions/create"], {state: {selectedNiche: this.selectedNiche, selectedProducer: this.selectedProducerCode, isBusinessLookup: this.isBusinessLookup, isDice: this.selectedNiche.isDice}});
      }
    }
    this.isSubmitted = true;
  }

  ngOnDestroy() {
    //WE DONT WONT TO KILL FETCH-NICHES MODAL SERVICE WHEN WE GO TO DICE QUOTE LIST.. SO NOT ADDING SUBSCRIPTION INTO commonService RUNNINSERVICES.
    this.runningServices.forEach(subscription =>subscription.unsubscribe());
  }
}
